﻿import { SelectOption } from '../inputs/SelectInput';

// Helper function to get grecaptcha, checking window dynamically
export const getGrecaptcha = (): Window['grecaptcha'] | undefined => {
    if (typeof window === 'undefined') return undefined;
    return (window as any).grecaptcha;
};

// Helper function to wait for reCAPTCHA to load
export const waitForRecaptcha = (maxWait = 5000): Promise<Window['grecaptcha']> => {
    return new Promise((resolve, reject) => {
        const startTime = Date.now();
        
        const checkRecaptcha = () => {
            const grecaptcha = getGrecaptcha();
            if (grecaptcha) {
                resolve(grecaptcha);
                return;
            }
            
            if (Date.now() - startTime > maxWait) {
                reject(new Error('reCAPTCHA script failed to load within timeout'));
                return;
            }
            
            setTimeout(checkRecaptcha, 100);
        };
        
        checkRecaptcha();
    });
};

export interface Locale {
    code: string;
    name: string;
}

export interface Retailer {
    id: string;
    name: string;
    localeCode?: string;
    localeName?: string;
}

export interface Courier {
    id: string;
    name: string;
    localeName?: string;
}

export interface FormErrors {
    [key: string]: string[];
}

export interface FormValues {
    submissionType: string;
    // Retailer fields
    retailerName: string;
    retailerLocaleCode: string;
    retailerUrl: string;
    retailerDescription: string;
    selectedRetailerCourierIds: string[];
    // Courier fields
    selectedRetailerId: string;
    isNewCourier: boolean;
    courierLocaleCode: string;
    selectedCourierId: string;
    courierName: string;
    courierUrl: string;
    courierComments: string;
    // Locale fields
    newLocaleCode: string;
    isoLocales?: SelectOption[];
}
